import '../App.css';
const About = () => {
	return (
		<div className='background-size'>
		<main>
			<div className="container">
				<div className="aboutpage">
					<div className="aboutpagel">
						<div className="header-title ">
							<h1>about us</h1>
							<h2>“Safety is not expensive, Human life is Priceless” - Mr. Sims</h2>
						</div>
						<br />
						<p style={{ fontSize: '18px' }}>
							SIMS Solutions, founded on December 1, 2021, and headquartered in Muscat, the capital city of the Muscat Governorate in the Sultanate of Oman.
						</p>
						<p style={{ fontSize: '18px' }}>
							All aspects of human activities and work are being integrated into technological systems through the use of software’s, machine learning and artificial intelligence. these include the advancement of HSE into machine learning and artificial intelligence software systems. 
						</p>
						<p style={{ fontSize: '18px' }}>
							Concerning HSE, SIMS (Smart, intelligent, management, system) was preconceived to help develop HSE into a tech-friendly system. SIMS is utilized by SMART SOLUTIONS company is introduced to organizations and companies in the middle east to make administration of HSE among workers and operators convenient and prompt. The Company will utilize the most user-friendly software to ensure a safer and healthier workplace and environment.
						</p>
						<ul style={{ fontSize: '16px', lineHeight: '1.6', wordBreak: 'break-all' }}>
							<li>Improved HSE compliance</li>
							<li>Improved Operations productivity</li>
							<li>Improved employee engagement</li>
							<li>Improved visibility into HSE performance</li>
							<li>Enhanced HSE communication and collaboration.</li>
							<li>Increasing the return of investment (ROI)</li>
							<li>Reduce cost on insurance premiums</li>
							<li>Decreasing all levels of accidents and incidents</li>
							<li>Reduced environmental impact</li>
							<li>Reduced administrative burden</li>
							<li>Lead high level of risk mitigations</li>
							<li>Lead to productivity & opportunities for growth</li>
						</ul>
						
					</div>
					<div className="aboutpager">
						<img src="img/bgabout.png" alt=''/>
					</div>
				</div>
			</div>
		</main>
		</div>
	);
}
export default About;
// “Safety is not expensive, Human life is Priceless” Mr. Sims… 


// SIMS Solutions, founded on December 1, 2021, and headquartered in Muscat, the capital city of the Muscat Governorate in the Sultanate of Oman, 

// All aspects of human activities and work are being integrated into technological systems through the use of software’s, machine learning and artificial intelligence. these include the advancement of HSE into machine learning and artificial intelligence software systems. 
// Concerning HSE, SIMS (Smart, intelligent, management, system) was preconceived to help develop HSE into a tech-friendly system. SIMS is utilized by SMART SOLUTIONS company is introduced to organizations and companies in the middle east to make administration of HSE among workers and operators convenient and prompt. The Company will utilize the most user-friendly software to ensure a safer and healthier workplace and environment.

//     • Improved HSE compliance
//     • Improved Operations productivity
//     • Improved employee engagement
//     • Improved visibility into HSE performance
//     • Enhanced HSE communication and collaboration.
//     • Increasing the return of investment (ROI)
//     • Reduce cost on insurance premiums
//     • Decreasing all levels of accidents and incidents
//     • Reduced environmental impact
//     • Reduced administrative burden
//     • Lead high level of risk mitigations
//     • Lead to productivity & opportunities for growth